import { Outlet, Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';


const ProtectedRoutes = () => {

  const { auth, Loading } = useAuth();

  const location = useLocation();
  console.log("ProtectedRoutes mounted");
  console.log(auth.status);
  if(Loading) {
    return null;
  }
  return (
    auth?.status 
    ? <Outlet /> 
    : <Navigate to="/login" state={{ from: location }} replace /> 
  )
}

export default ProtectedRoutes;
